import API from 'src/services/api';
import { User, UserEntitlements, UserSettings } from './types';
import { AxiosResponse } from 'axios';

const usersApi = {
  async fetchUser(): Promise<AxiosResponse<User>> {
    return await API.get('/user');
  },
  async fetchUserEntitlements(): Promise<AxiosResponse<UserEntitlements>> {
    return await API.get('/user/entitlements');
  },
  async fetchUserSettings(): Promise<AxiosResponse<UserSettings>> {
    return await API.get('/user/config');
  },
  async updateUserSettings(options: UserSettings): Promise<AxiosResponse<UserSettings>> {
    return await API.put('/user/config', options);
  },
};

export default usersApi;
